import { useEffect, useState } from "react";
import mainStyle from "../mainStyle.module.scss";

// material-ui
import { useTheme } from "@mui/material/styles";
import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";

// project import

import CustomMenu from "components/Menu";

// assets

import { ReactComponent as ChevronUp } from "assets/images/icons/icn_pagination_chevron_up.svg";
import { ReactComponent as ChevronDown } from "assets/images/icons/icn_pagination_chevron_down.svg";
import { ReactComponent as ChevronDownHover } from "assets/images/icons/icn_pagination_chevron_down_hover.svg";

export const MenuSelect = ({
  value,
  onChange,
  options,
  width,
  menuWidth,
  placeholder,
}) => {
  const theme = useTheme();

  const [anchorEl, setAnchorEl] = useState(null);
  const [chevronHover, setChevronHover] = useState(false);

  const menuOpen = Boolean(anchorEl);

  const handleOpen = (event) => {
    event.stopPropagation();
    if (anchorEl) {
      setAnchorEl(null);
    } else {
      setAnchorEl(event.currentTarget);
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
    setChevronHover(false);
  };

  return (
    <Box
      onClick={handleOpen}
      onMouseEnter={() => setChevronHover(true)}
      onMouseLeave={() => setChevronHover(false)}
      sx={{
        position: "relative",
        display: "flex",
        alignItems: "center",
        border: `1px solid ${
          !!anchorEl
            ? theme.palette.primary.main
            : chevronHover
            ? theme.palette.primary.mainHover
            : theme.palette.primary.borderGreyPrimary
        }`,
        borderRadius: theme.shape.customBorderRadius[1],
        mr: 1,
        width: width,
        height: 32,
        bgcolor: theme.palette.primary.white,
        px: 1,
        cursor: "pointer",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          overflow: "hidden",
          flexGrow: 1,
        }}
      >
        <Typography
          sx={{
            fontSize: theme.typography.customFontSize[2],
            color: theme.palette.primary.greyPrimary,
            fontWeight: theme.typography.customFontWeight[3],
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            fontFamily: "Open Sans",
          }}
        >
          {value || (
            <span style={{ color: theme.palette.primary.greyThird }}>
              {placeholder}
            </span>
          )}
        </Typography>
      </Box>

      <Box
        sx={{
          position: "absolute",
          top: 0,
          right: 0,
          width: 32,
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderTopRightRadius: 6,
          borderBottomRightRadius: 6,
          pointerEvents: "auto",
        }}
      >
        {menuOpen ? (
          <ChevronUp />
        ) : chevronHover ? (
          <ChevronDownHover />
        ) : (
          <ChevronDown />
        )}
      </Box>
      <CustomMenu
        anchorEl={anchorEl}
        open={menuOpen}
        handleMenuClose={handleClose}
        maxWidth={menuWidth}
        minWidth={'170px'}
        mt={0.5}
        ml={0}
        borderLeftWidth="0px"
        borderRightWidth="0px"
        borderBottomWidth="0px"
      >
        <List
          className={mainStyle["custom-scrollbar-menu"]}
          sx={{
            paddingTop: "5px",
            paddingLeft: "10px",
            maxHeight: "180px",
            overflowY: "auto",
            overflowX: "hidden",
            boxSizing: "content-box",
            marginRight: "10px",
          }}
        >
          {options.map((opt, index) => (
            <ListItem
              key={opt.label}
              button
              selected={value === opt.value}
              onClick={(e) => {
                e.stopPropagation();
                onChange(opt);
                handleClose();
              }}
              sx={{
                color: theme.palette.primary.main,
                paddingLeft: "10px",
                margin: "5px 5px 0 0",
                borderRadius: theme.shape.customBorderRadius[0],
                height: "40px",
                "&:hover": { backgroundColor: theme.palette.primary.lightBlue },
                "&.Mui-selected": {
                  backgroundColor: theme.palette.primary.subBlue,
                },
              }}
            >
              <ListItemText
                primary={opt.value}
                primaryTypographyProps={{
                  style: {
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                    fontSize: theme.typography.customFontSize[2],
                  },
                }}
              />
            </ListItem>
          ))}
        </List>
      </CustomMenu>
    </Box>
  );
};
